import React from 'react';
import CountUp from 'react-countup';
import VisibilitySensor from 'react-visibility-sensor';
import { Flex, Text, Box } from '@chakra-ui/react';
import SanityImage from 'gatsby-plugin-sanity-image';

function StatGridItem({ item }) {
  const { number, afterText, prefix, suffix, icon } = item || {};
  return (
    <Flex direction='column' padding={30} textAlign='left' background='grey.light' height='100%'>
      <Flex width='100%' gap={10} alignItems='center'>
        {icon && (
          <Flex alignItems='center' height='100%' width='50px'>
            <SanityImage {...icon} alt={icon?.asset?.altText} width={100} height={100} />
          </Flex>
        )}
        <Box color='navy'>
          {number ? (
            <VisibilitySensor>
              {({ isVisible }) => (
                <CountUp
                  end={number}
                  duration={1.5}
                  start={isVisible}
                  delay={0}
                  prefix={prefix !== undefined ? prefix : ''}
                  suffix={suffix !== undefined ? suffix : ''}
                  separator=','
                >
                  {({ countUpRef }) => (
                    <Text
                      fontSize='6xl'
                      lineHeight={1.1}
                      fontWeight={600}
                      ref={countUpRef}
                      mt={0}
                    />
                  )}
                </CountUp>
              )}
            </VisibilitySensor>
          ) : (
            <Text fontSize='6xl' lineHeight={1.1} fontWeight={600} mt={0}>
              {prefix !== undefined ? prefix : ''}
              {suffix !== undefined ? suffix : ''}
            </Text>
          )}
        </Box>
      </Flex>
      <Box width='100%'>
        {afterText && (
          <Text fontWeight={500} marginTop={0}>
            {afterText}
          </Text>
        )}
      </Box>
    </Flex>
  );
}

export default StatGridItem;
